import React, { memo } from 'react';
import { T } from '../../translation/src';

export interface BalanceOverviewProps {
  available: number;
  // Why adding a project is blocked, when it is.
  blockedReason?: string;
}

// The projects a new upload may draw on, for a hover.
const BalanceOverview_: React.FC<BalanceOverviewProps> = ({ available, blockedReason }) => (
  <div className="flex max-w-72 flex-col gap-1.5">
    <span className="text-base font-semibold">
      {available} {available === 1 ? <T _str="project available" /> : <T _str="projects available" />}
    </span>
    {blockedReason && <span className="text-xs text-warning-yellow-700 dark:text-warning-yellow-500">{blockedReason}</span>}
  </div>
);
export const BalanceOverview = memo(BalanceOverview_);
